module.exports = "<button class=uk-button @click=clicked :class=\"[classes, {\n    'tm-button-half': half\n  }]\" :disabled=disabled :type=type :title=\"disabled ? '' : title\" :data-uk-tooltip=\"disabled ? false : '{ delay: 500 }'\"> <i v-if=icon class=\"uk-icon-justify uk-icon-{{ icon }}\"></i> {{ text }} <slot></slot> </button>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TmButton.vue
 ** module id = 264
 ** module chunks = 0
 **/